// extracted by mini-css-extract-plugin
export default {"errorPayment":"Payment_errorPayment__v9eRz","CommonModal":"Payment_CommonModal__+J4+O"};